module.exports = __webpack_public_path__ + "img/coments.d9a4be7e.svg";